import { createSelector } from 'reselect';

export const notCorrectExamSelector = state => state.notCorrectExam;

export const visibleFormNotCorrectExamSelector = createSelector(
  notCorrectExamSelector,
  subState => subState.visibleForm
);

export const formNotCorrectExamSelector = createSelector(
  notCorrectExamSelector,
  subState => subState.form
);

export const emailNotCorrectExamSelector = createSelector(
  formNotCorrectExamSelector,
  subState => subState.email
);

export const loadingNotCorrectExamSelector = createSelector(
  notCorrectExamSelector,
  subState => subState.loading
);

export const phoneNotCorrectExamSelector = createSelector(
  formNotCorrectExamSelector,
  subState => subState.phone
);

export const commentNotCorrectExamSelector = createSelector(
  formNotCorrectExamSelector,
  subState => subState.comment
);
